import React, { useEffect, useRef } from 'react'
import AniLink from 'gatsby-plugin-transition-link/AniLink'
import * as E from '../../elementor'
import Slide from './slide'
import parse from 'html-react-parser'
import { register } from 'swiper/element/bundle'
import SwiperNext from '../../images/swiper-right.svg'
import SwiperPrev from '../../images/swiper-left.svg'

import 'swiper/scss'
import 'swiper/scss/navigation'
register()

const Directory = ({ section }) => {
  const swiperRef = useRef(null)
  const nextRef = useRef(null)
  const prevRef = useRef(null)

  const { slides, heading, textEditor, button, basicGallery } = E.collect(section)

  const title = heading[0]?.title || ''
  const upperSubTitle = textEditor[0]?.text() || ''
  const ctaButton = button[0]?.text
  const ctaLink = button[0]?.link
  const ctaID = button[0]?.button_css_id
  const ctaText = textEditor[1]?.text() || ''
  const slideGroup = slides[0]?.slides
  const slideID = slides[0]?.cssId ?? ''

  useEffect(() => {
    const swiperContainer = swiperRef.current
    const params = {
      slidesPerView: 1,
      spaceBetween: 10,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: nextRef.current,
        prevEl: prevRef.current
      },
      scrollbar: true,
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 10,
          centeredSlides: true
        },
        480: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 40
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 16
        }
      },
      injectStyles: [
        `
          .swiper-container {
            padding-left: 1rem;
          }
          .swiper-button-disabled {
            display: none;
          }
          .swiper-wrapper {
            margin-bottom: 3.75rem;
          }
          .swiper-scrollbar {
            background: #f5f5f5;
          }
          .swiper-scrollbar.swiper-scrollbar-horizontal {
            height: 2px;
          }
          .swiper-scrollbar-drag {
            background: #262626;
          }
      `
      ]
    }

    if (swiperContainer !== undefined && swiperContainer !== null) {
      Object.assign(swiperContainer, params);
      (swiperContainer as any).initialize()
    }
  }, [])

  return (
    <section>
      <div className='directory-wrapper'>
        <div className='directory-title-wrapper'>
          <div className='directory-title'>
            <p className='subhead s5'>{parse(upperSubTitle)}</p>
            <h2>{parse(title)}</h2>
          </div>
          <div className='directory-cta'>
            <p>{parse(ctaText)}</p>
            <AniLink id={ctaID || ''} to={ctaLink} fade><button className='rula-button'>{ctaButton}</button></AniLink>
          </div>
        </div>
        <div className='directory-slides-wrapper'>
          <button ref={prevRef} className='swipe-prev' aria-label='Previous slide' style={{ backgroundImage: `url(${SwiperPrev})`}} />
          <swiper-container ref={swiperRef} navigation='true' init='false'>
            {slideGroup?.map((slide, index) => {
              return <Slide slide={slide} img={basicGallery[0]?.images[index]} key={index} slideID={slideID} />
            })}
          </swiper-container>
          <button ref={nextRef} className='swipe-next' aria-label='Next slide' style={{ backgroundImage: `url(${SwiperNext})`}} />
        </div>
        <div className='directory-cta-mobile'>
          <p className='paragraph-large'>{parse(ctaText)}</p>
          <AniLink id={ctaID || ''} to={ctaLink} fade>
            <button>{ctaButton}</button>
          </AniLink>
        </div>
      </div>
    </section>
  )
}

export default Directory
